module.exports = __webpack_public_path__ + "img/qingtong-lily.b2f242df.png";